<template>
  <div>
    <el-dialog
        title="详情"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose"
        :close-on-click-modal="false"
        center
    >
      <ul class="content-wrap">
        <li>
          <div class="label">订单编号：</div>
          <div class="content">{{ info.orderIds && info.orderIds[0] || '' }}</div>
        </li>
        <li>
          <div class="label">支付方式：</div>
          <div class="content">{{ info.orderPayTypes && info.orderPayTypes[0] || '' }}</div>
        </li>
        <li>
          <div class="label">发票编号：</div>
          <div class="content">{{ info.invoiceId || '' }}</div>
        </li>
        <li>
          <div class="label">发票类型：</div>
          <div class="content">{{ invoiceType(info.invoiceType) }}</div>
        </li>
        <li>
          <div class="label">发票抬头：</div>
          <div class="content">{{ info.invoiceTitle || '' }}</div>
        </li>
        <li>
          <div class="label">税号：</div>
          <div class="content">{{ info.invoiceDutyParagraph || '' }}</div>
        </li>
        <li>
          <div class="label">创建时间：</div>
          <div class="content">{{ info.invoiceCreateTime || '' }}</div>
        </li>
        <li>
          <div class="label">开票状态：</div>
          <div class="content">{{ invoiceMakeOutStatus(info.invoiceMakeOutStatus) }}</div>
        </li>
        <li>
          <div class="label">开户行及账户：</div>
          <div class="content">{{ info.invoiceBankAccount || '' }}</div>
        </li>
        <li>
          <div class="label">地址和电话：</div>
          <div class="content">{{ info.invoiceAddressPhone || '' }}</div>
        </li>
        <li>
          <div class="label">电子邮箱：</div>
          <div class="content">{{ info.invoiceEmail }}</div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
        <!--        <el-button type="primary" @click="close">确 定</el-button>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "orderDetailDialog",
  data() {
    return {
      dialogVisible: false,
      invoiceId: -1,
      info: {}
    }
  },
  methods: {
    invoiceMakeOutStatus(type) {
      if (type == 0) return '开票中'
      else if (type == 1) return '已开'
      else if (type == 2) return '完成'
      else if (type == 3) return '重开'
      else if (type == 4) return '已废弃'
      else if (type == 5) return '未支付'
      else if (type == 9) return '退票中'
      else if (type == 10) return '已退票'
      else return '未知'
    },
    invoiceType(type) {
      return type == 1 ? '单位' : '个人'
    },
    open(id) {
      this.invoiceId = id
      this.dialogVisible = true
      this.getOrderDetail()
    },
    // close() {
    //   this.$emit('update')
    //   this.dialogVisible = false
    //
    // },
    handleClose() {
      this.$emit('update')
      this.dialogVisible = false
    },

    // 获取订单详情
    async getOrderDetail() {
      let res = await this.$request.getInvoiceDetail({id: this.invoiceId})
      if (res.status === 200) {
        this.info = res.data
        await this.$store.dispatch('changeInvoiceNum')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  li {
    display: flex;
    min-height: 35px;
    line-height: 35px;

    .label {
      width: 120px;
      text-align: right;
      margin-right: 4px;
    }

    .content {
      flex: 1;
    }
  }
}
</style>